//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

const { FeatureNames } = require('@bvengineering/curalate-features');

(function () {
  const curalate = angular.module('curalate');

  curalate.component('sourcesTree', {
    bindings: {
      searchFilterSetName: '<',
      defaultInstagramAccount: '<',
      defaultTikTokAccount: '<',
      curalateUsers: '<',
      trackedHashtags: '<',
      trackedUsers: '<',
      trackedCompetitors: '<',
      viewAllClicked: '&',
    },
    template: require('@legacy-components/content/sources-tree/sources-tree.html'),
    controller: [
      'rx',
      'SearchFilterService',
      'SessionVarsService',
      'COLLECTION_SETTINGS',
      'SEARCH_FILTERS',
      function (
        rx,
        SearchFilterService,
        SessionVarsService,
        COLLECTION_SETTINGS,
        SEARCH_FILTERS,
      ) {
        const self = this;
        let filterValue;
        const ngUnsubscribe = new rx.Subject();

        self.MAX_TEAM_MEMBERS = 10;
        self.MAX_TRACKED_USERS = 10;
        self.MAX_TRACKED_COMPETITORS = 25;
        self.MAX_TRACKED_HASHTAGS = 10;

        self.filterText = '';
        self.pinterestUserId = SessionVarsService.getPinterestUserId();
        self.pinterestUsername = SessionVarsService.getPinterestUsername();
        self.isInstagramCompetitorsEnabled =
          SessionVarsService.isFeatureEnabled('instagram_competitors');
        self.isDamImportDropboxEnabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.DamImportDropbox,
        );

        self.isMultiHandleFeatureEnabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.MultiHandleInstagram,
        );
        function Comparator(selections) {
          this.selections = selections;
        }

        Comparator.prototype.compare = function (one, two) {
          let compareValue;

          if (
            this.selections.indexOf(one.id) !== -1 &&
            this.selections.indexOf(two.id) === -1
          ) {
            compareValue = -1;
          } else if (
            this.selections.indexOf(one.id) === -1 &&
            this.selections.indexOf(two.id) !== -1
          ) {
            compareValue = 1;
          } else {
            compareValue = one.name.localeCompare(two.name);
          }

          return compareValue;
        };

        const filterResults = function (item) {
          return (
            !self.filterText ||
            self.filterText.trim().length === 0 ||
            item.name.toLowerCase().indexOf(self.filterTextLowerCase) >= 0
          );
        };

        const updateFilteredItems = function () {
          const curalateUsersComparator = new Comparator(
            filterValue[COLLECTION_SETTINGS.FILTERS.CURALATE_USER_IDS],
          );
          self.filteredCuralateUsers = _(self.curalateUsers).filter(
            filterResults,
          );
          self.filteredCuralateUsers.sort((a, b) => {
            return curalateUsersComparator.compare(a, b);
          });

          const trackedHashtagsComparator = new Comparator(
            filterValue[COLLECTION_SETTINGS.FILTERS.TRACKED_HASHTAGS],
          );
          self.filteredTrackedHashtags = _(self.trackedHashtags).filter(
            filterResults,
          );
          self.filteredTrackedHashtags.sort((a, b) => {
            return trackedHashtagsComparator.compare(a, b);
          });

          const trackedUsersComparator = new Comparator(
            filterValue[COLLECTION_SETTINGS.FILTERS.TRACKED_USER_IDS],
          );
          self.filteredTrackedUsers = _(self.trackedUsers).filter(
            filterResults,
          );
          self.filteredTrackedUsers.sort((a, b) => {
            return trackedUsersComparator.compare(a, b);
          });

          const trackedCompetitorsComparator = new Comparator(
            filterValue[COLLECTION_SETTINGS.FILTERS.TRACKED_USER_IDS],
          );
          self.filteredTrackedCompetitors = _(self.trackedCompetitors).filter(
            filterResults,
          );
          self.filteredTrackedCompetitors.sort((a, b) => {
            return trackedCompetitorsComparator.compare(a, b);
          });
        };

        self.filterTextChanged = function () {
          self.filterTextLowerCase = self.filterText.toLowerCase();
          updateFilteredItems();
        };

        self.clearButtonClicked = function () {
          self.filterText = '';
          updateFilteredItems();
        };

        // If the user clicked the clear button, re-focus the sources tree before the cu-popover tries to close it
        self.focusSourcesTreeInput = () => {
          angular.element('#sources-tree-input-text').focus();
        };

        self.$onInit = function () {
          // Lookup the filter set's state directly to workaround DEV-27083
          const filterSet = SearchFilterService.getRegisteredSet(
            SEARCH_FILTERS.CONTENT_LIBRARY_USERS_DROPDOWN_FILTERS,
          );
          filterValue = filterSet.params;

          updateFilteredItems();

          SearchFilterService.getObservableForFilterSet(
            SEARCH_FILTERS.CONTENT_LIBRARY_USERS_DROPDOWN_FILTERS,
          )
            .takeUntil(ngUnsubscribe)
            .subscribe((setUpdate) => {
              filterValue = setUpdate.setObject;

              updateFilteredItems();
            });
        };

        self.$onDestroy = function () {
          ngUnsubscribe.next();
          ngUnsubscribe.complete();
        };
      },
    ],
  });
})();
